/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SiegeLieuSuiviFichierDto
 */
export interface SiegeLieuSuiviFichierDto {
    /**
     * 
     * @type {number}
     * @memberof SiegeLieuSuiviFichierDto
     */
    idsiegeLieuSuiviFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof SiegeLieuSuiviFichierDto
     */
    idsiegeSocialLieuFormationSuivi?: number;
    /**
     * 
     * @type {number}
     * @memberof SiegeLieuSuiviFichierDto
     */
    idfichier?: number;
    /**
     * 
     * @type {number}
     * @memberof SiegeLieuSuiviFichierDto
     */
    idtypeSuiviFichier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SiegeLieuSuiviFichierDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the SiegeLieuSuiviFichierDto interface.
 */
export function instanceOfSiegeLieuSuiviFichierDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SiegeLieuSuiviFichierDtoFromJSON(json: any): SiegeLieuSuiviFichierDto {
    return SiegeLieuSuiviFichierDtoFromJSONTyped(json, false);
}

export function SiegeLieuSuiviFichierDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiegeLieuSuiviFichierDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idsiegeLieuSuiviFichier': !exists(json, 'idsiegeLieuSuiviFichier') ? undefined : json['idsiegeLieuSuiviFichier'],
        'idsiegeSocialLieuFormationSuivi': !exists(json, 'idsiegeSocialLieuFormationSuivi') ? undefined : json['idsiegeSocialLieuFormationSuivi'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'idtypeSuiviFichier': !exists(json, 'idtypeSuiviFichier') ? undefined : json['idtypeSuiviFichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function SiegeLieuSuiviFichierDtoToJSON(value?: SiegeLieuSuiviFichierDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idsiegeLieuSuiviFichier': value.idsiegeLieuSuiviFichier,
        'idsiegeSocialLieuFormationSuivi': value.idsiegeSocialLieuFormationSuivi,
        'idfichier': value.idfichier,
        'idtypeSuiviFichier': value.idtypeSuiviFichier,
        'fileName': value.fileName,
    };
}

